import icon_lock from "../images/lock_white.png";
import icon_rec from "../images/timeshift_white.png";
import icon_premium from "../images/prem_white.png";

export default function MiniCardChannel({
    elem,
    index,
    activeChannel,
    btn_channel_live_fields,
    doubleClickChannel,
    class_name,
    active_channel,
    channel
}) {

    return (

        <div
            onDoubleClick={() => doubleClickChannel ? doubleClickChannel(elem) : null}
            onClick={() => btn_channel_live_fields(elem, index)}
            className={"card_channel_categories " + (class_name ? class_name : '')}
            style={active_channel ? active_channel.id === elem.id ? { borderColor: 'white' } : null : (channel && channel.id === elem.id ? { borderColor: 'white' } : null)}
        >

            <p className={'num_card_channels'}>{index + 1}</p>
            <div className="image_card_channels">
                <img src={elem.image} alt="" />
            </div>
            <h1 className="name_card_channels">
                {elem.name}
            </h1>
            <div className="icons_content_player">
                {elem.is_protected ?
                    <img className={'icon_lock_mini_card icon_mini_card'} src={icon_lock} alt="" /> :
                    <div className="no_icons no_icons_lock"></div>
                }
                {elem.archived_channel ?
                    <img className={'icon_rec_mini_card icon_mini_card'} src={icon_rec} alt="" /> :
                    <div className="no_icons no_icons_rec"></div>
                }
                {!elem.canWatch ?
                    <img className={'icon_premium_mini_card icon_mini_card'} src={icon_premium} alt="" /> :
                    <div className="no_icons no_icons_prem"></div>
                }
            </div>

        </div>
    )
}